export default __webpack_public_path__ + "static/media/logoSoap.66512563.png";